module.exports = __webpack_public_path__ + "resources/img/img_tibero5_m.2407ebde10b4ea4bab2dccc009a05e40.png";